import type { MouseEventHandler } from 'react'
import { useTranslation } from 'react-i18next'
import IcBaselineArrowRightAlt from '~icons/ic/baseline-arrow-right-alt'
import { cx } from 'src/utils/cx'

export function MembershipSwitchModeBtn(
  props: {
    onClick?: MouseEventHandler<HTMLButtonElement>
    mode?: 'plans' | 'packs'
  } & StyleProps,
) {
  const { t } = useTranslation(['membership', 'growth'])

  return (
    <button className={cx(props.className)} onClick={props.onClick}>
      <IcBaselineArrowRightAlt className="size-4 shrink-0" />
      <span>
        {props.mode === 'plans'
          ? t('membership:switch-to.credit-packs')
          : t('membership:switch-to.membership')}
      </span>
    </button>
  )
}
